import { render } from "./ProductRunsGraph.vue?vue&type=template&id=37ec64a2&scoped=true"
import script from "./ProductRunsGraph.vue?vue&type=script&lang=js"
export * from "./ProductRunsGraph.vue?vue&type=script&lang=js"

import "./ProductRunsGraph.vue?vue&type=style&index=0&id=37ec64a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ec64a2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QBadge});
